import { render, staticRenderFns } from "./BooksPage.vue?vue&type=template&id=660fabec&"
import script from "./BooksPage.vue?vue&type=script&lang=js&"
export * from "./BooksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports